<template>
  <div>
    <div class="message is-info">
      <!-- <div class="message-body has-text-dark">
        <p class="is-size-4">
          A domain record is blah blah
        </p>
      </div> -->
    </div>
    <div class="flex-table">
      <div class="flex-thead">
        <div class="flex-row">
          <div class="flex-th">
            {{ $t('domains.records.th_type') }}
          </div>
          <div class="flex-th">
            {{ $t('domains.records.th_name') }}
            <span
              class="tooltip is-tooltip-right is-tooltip-multiline"
              :data-tooltip="$t('domains.records.tt_name')"
            >
              <font-awesome-icon
                icon="question-circle"
                color="var(--form-color-light)"
                :style="{marginLeft: '5px'}"
              />
            </span>
          </div>
          <div class="flex-th">
            {{ $t('domains.records.th_value') }}
            <span
              class="tooltip is-tooltip-right is-tooltip-multiline"
              :data-tooltip="$t('domains.records.tt_value')"
            >
              <font-awesome-icon
                class="tooltip"
                icon="question-circle"
                color="var(--form-color-light)"
                :style="{marginLeft: '5px'}"
                data-tooltip="Tooltip Text"
              />
            </span>
          </div>
          <div class="flex-th small">
            {{ $t('domains.records.th_priority') }}
          </div>
          <div class="flex-th small" />
        </div>
      </div>
      <transition-group
        name="fade"
        tag="div"
        class="flex-body"
      >
        <div
          v-for="row in rows"
          :key="row.identifier"
          class="form-section-bg flex-row"
        >
          <div class="flex-cell">
            <div class="cell-content">
              <span class="cell-heading">{{ $t('domains.records.th_type') }}</span>
              <custom-input
                stop-clearfix
                :label-as-a-container="false"
              >
                <multiselect
                  v-model="row.type"
                  :options="allowedRecordTypes"
                  :multiple="false"
                  placeholder="Select record"
                  :close-on-select="true"
                  track-by="code"
                  label="name"
                  :show-labels="false"
                />
              </custom-input>
            </div>
          </div>
          <div class="flex-cell">
            <div class="cell-content">
              <span class="cell-heading">{{ $t('domains.records.th_name') }}</span>
              <custom-input
                v-model="row.name"
                stop-clearfix
              />
            </div>
          </div>
          <div class="flex-cell">
            <div class="cell-content">
              <span class="cell-heading">{{ $t('domains.records.th_value') }}</span>
              <custom-input
                v-model="row.value"
                stop-clearfix
              />
            </div>
          </div>
          <div class="flex-cell small">
            <div class="cell-content">
              <span class="cell-heading">{{ $t('domains.records.th_priority') }}</span>
              <span :style="{ color: 'black' }">{{ row.identifier }}</span>
            </div>
          </div>
          <div class="flex-cell small">
            <div class="cell-content">
              <span class="cell-heading" />
              <font-awesome-icon
                icon="trash"
                color="var(--primary-color)"
                @click="removeRow(row.identifier)"
              />
            </div>
          </div>
        </div>
      </transition-group>
    </div>
    <div class="form-section-bg table-foot">
      <button
        class="button is-primary is-broad is-large is-uppercase"
        @click="addRow"
      >
        {{ $t('domains.buttons.add_record') }}
      </button>
    </div>
  </div>
</template>

<script>
import CustomInput from '@/components/Shared/CustomInput'
import Multiselect from 'vue-multiselect'

const rowTemplate = {
  identifier: 0,
  type: null,
  name: '',
  value: '',
  priority: ''
}

export default {

  name: 'DomainTable',
  components: {
    CustomInput,
    Multiselect
  },
  data () {
    return {
      recordTypes: null,
      rowCount: 0,
      rows: [
        { ...rowTemplate }
      ]
    }
  },
  computed: {
    allowedRecordTypes () {
      return [
        { name: 'A', code: 'a_record' },
        { name: 'AAAA', code: 'aaaa_record' },
        { name: 'CNAME', code: 'cname_record' },
        { name: 'MX', code: 'mx_record' },
        { name: 'TXT', code: 'txt_record' }
      ]
    }
  },
  methods: {
    addRow () {
      this.rowCount++
      this.rows.push(
        { ...rowTemplate, identifier: this.rowCount }
      )
    },
    removeRow (identifier) {
      this.rows = this.rows.filter(row => row.identifier !== identifier)
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';
.flex-table {
  width: 100%;
}

.flex-thead {
  padding: 10px 0;
  padding-left: 10px;
  background-color: var(--primary-color);
  margin-bottom: 5px;
}

.flex-row {
  display: flex;
  justify-content: space-evenly;
  text-align: center;
  align-items: center;
}

.flex-cell, .flex-th {
  flex: 3;
  padding: 0 10px;

  &.small {
    flex: 1;
  }
}

.flex-th {
  text-align: left;
}

.cell-heading {
  display: none;
}
.cell-content {
  display: flex;
  flex: 1;
  align-items: center;
  align-self: stretch;
  height: 100%;

  > * {
    flex: 1;
  }
}

@media only screen and (max-width: $break-small) {
  .flex-thead {
    display: none;
  }
  .flex-row {
    flex-direction: column;
    align-items: stretch;
    margin: 5px;
    height: 300px;
  }

  .flex-cell, .flex-th {
    flex: 1;
    padding: 0 10px 0 0;
    height: 40px;

    &.small {
      flex: 1;
    }
  }

  .cell-heading {
    display: flex;
    max-width: 80px;
    background-color: var(--primary-color);
    align-self: stretch;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    min-height: 100%;
  }
}

.domain-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 5px;

  .head-row {
    background-color: var(--primary-color);
    th {
      color: white;
      padding: 5px 15px;
    }
  }
}

.domain-table-row {
  margin: 30px;
  td {
    padding: 0 10px;
    vertical-align: middle;
  }
}

.table-foot {
  padding: 10px 10px;
  margin-top: 5px;
}

.form-section-bg {
  background-color: var(--form-color-light);
  margin-bottom: 5px;
}

</style>
